import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { setBatchesTableCellTestId } from "../batches-table.utils";

export const WeightCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
  const { t } = useTranslation();
  const totalWeightInGrams = props.row.original.totalWeightInGrams;

  if (totalWeightInGrams === undefined) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  return (
    <span className="text-sm" data-testid={setBatchesTableCellTestId("totalWeightInGrams", props.row.index)}>
      {t("weight.weightWithSuffix", { grams: totalWeightInGrams })}
    </span>
  );
};
